import $ from '@nuskin/nuskinjquery';
import {UserService, AuthenticationService, VGDistInfoService} from "@nuskin/ns-account";
import {RunConfigService, storage, util, ShoppingContext, Base64, events} from "@nuskin/ns-util";
import CartService from './cart/cartService';
import AdrService from './adr/AdrService';
import {getCachedConfigField} from '@nuskin/configuration-sdk';

const PARAMS_COOKIE = "parametersJSON";
const removedParameters = {
    "addSkusToLandingPage": true,
    "adrSkus": true,
    "assessmentApp": true,
    "callbackUrl": true,
    "code": true,
    "landingPage": true,
    "orderSkus": true,
    "shoppingContext": true,
    "status": true,
    "orderReason": true,
    "adrContractId":true,
    "shipAddress": true,
    "gift": true,
    "initAdrOverride": true,
    "adrEcomm3OneTimePointRedemption": true,
    "dist_id": true,
    "first_name": true,
    "last_name":true,
    "scan_number":true
};
const RECEIVING_ITEMS = storage.metadata.RECEIVING_ITEMS;

let paramMap;
let adrEcomm3OneTimePointRedemption;
let user;

/**
 *
 * @return {string|*}
 */
const getUserRegion = () => {
    if (user && user.shipTo && user.shipTo.country === 'CA') {
        return user.shipTo.region;
    }
    return '';
};

/**
 *
 * @return {string|*}
 */
const getUserId = () => {
    if (user) {
        return user.id;
    }
    return '';
};

/**
 *
 * @return {*}
 */
const getRedirectPath = () => {
    return `${addParameters(window.location.pathname)}${window.location.hash}`;
};

/**
 *
 * @param path
 * @return {*}
 */
const buildAlternateHomeUrl =(path) => {
    return addParameters(path);
};

/**
 * Add parsed SKUs to an array
 *
 * @param retSkus
 * @param skusString
 * @param isAdr
 */
const addSkusToArray = (retSkus, skusString, isAdr) => {
    const skus = skusString.split(',');
    for (let i = 0; i < skus.length; i++) {
        let parts = skus[i].split(':');
        retSkus.push({
            sku: parts[0],
            qty: parts.length > 1 ? parts[1] : 1,
            maxQty: parts.length > 2 ? parts[2] : 999,
            adr: isAdr
        });
    }
};

/**
 * Builds a url string
 *
 * @param path
 * @return {*}
 */
const addParameters = (path) => {
    let retVal = path;
    let i = 0;
    for (let key in paramMap) {
        if (paramMap.hasOwnProperty(key)) {
            if (!removedParameters.hasOwnProperty(key)) {
                if (i === 0) {
                    retVal += "?" + key + "=" + paramMap[key];
                } else {
                    retVal += "&" + key + "=" + paramMap[key];
                }
                i++;
            }
        }
    }
    return retVal;
};

/**
 *
 * @return {Array}
 */
const getItems = () => {
    const items = [];

    if (paramMap.orderSkus && paramMap.orderSkus.length > 0) {
        addSkusToArray(items, paramMap.orderSkus, false);
    }
    if (paramMap.adrSkus && paramMap.adrSkus.length > 0) {
        addSkusToArray(items, paramMap.adrSkus, true);
    }

    return items;
};

/**
 * Looks for items on the url to add to the cart.
 */
const addItemsToCart = async () => {
    // Add SKUs from query parameters to the cart
    const items = getItems();
    const runConfig = RunConfigService.getRunConfig();
    const promises = [];

    if (items.length > 0) {

        // This section sets up the page refresh listener unless this is also an ADR Override,
        // in which case the ADR Override handling block below will do so after completing its asynch calls
        if (!paramMap.initAdrOverride || !getCachedConfigField('keepCartOnAdrOverride')) {
            // Set recieving flag
            storage.setItem(RECEIVING_ITEMS, true);
            // setupListener(items.length, getRedirectPath());
        }

        for (let i = 0; i < items.length; i++) {
            const item = items[i],
                options = {
                    userId: getUserId(),
                    cntryCd: runConfig.country,
                    language: runConfig.language,
                    qty: item.qty,
                    maxQty: item.maxQty,
                    region: getUserRegion(),
                    isAdr: item.adr,
                    isAtpCheck: true
                };

            if (item.sku) {
                options.sku = item.sku;
                promises.push(CartService.addSkuToCart(options));
                // CartService.addSkuToCart(options).then(atpCallbackFn);
            }
        }
    }

    // (ADR Override only) add contents of the overridden ADR to the cart
    if (paramMap.initAdrOverride && getCachedConfigField('keepCartOnAdrOverride')) {
        AdrService.getAdrDetails(AdrService.getAdrOverrideId())
            .then(function(adr) {
                if (adr && adr['SalesOrderDetail']) {
                    const lineItems = adr.SalesOrderDetail.LineItemDetails || [];
                    if (lineItems.length === 0) return;

                    // Set page refresh listener to fire once all ADR items are copied to the cart
                    storage.setItem(RECEIVING_ITEMS, true);
                    // setupListener(lineItems.length, getRedirectPath());

                    lineItems.filter(function(item) {
                        return item.LineItem.ParentID === 0;
                    }).forEach(function(item) {
                        promises.push(CartService.addSkuToCart({
                            sku: item.LineItem.SKU,
                            qty: item.LineItem.RequestedQuantity,
                            redeem: item.LineItem.PayWithPoints,
                            cntryCd: util.countryCode,
                            language: util.languageCode,
                            userId: user.id
                        }));
                    });
                }
            })
            .catch(function(err) {console.error(err)});
    }

    if (adrEcomm3OneTimePointRedemption) {
        const items = AdrService.getAdrOneTimeItems();

        if (items.length < 1) {
            return;
        }

        // Set page refresh listener to fire once all ADR items are copied to the cart
        storage.setItem(RECEIVING_ITEMS, true);
        // setupListener(items.length, getRedirectPath());

        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            promises.push(CartService.addSkuToCart({
                cntryCd: util.countryCode,
                language: util.languageCode,
                redeem: item.payWithPoints,
                qty: item.quantity,
                sku: item.sku,
                userId: user.id
            }));
        }
    }

    try {
        await Promise.all(promises);
        storage.removeItem(RECEIVING_ITEMS);
        window.location = getRedirectPath();
    } catch (err) {
        console.error(err);
    }
};

const authenticateWithEid = async (eid) => {
    const user = UserService.getUser();
    if (user && Base64.decode(eid).indexOf(user.id) >= 0) {
        user.eid = eid;
        UserService.setUser(user);
        AuthenticationService.generateMecCookies();
    } else {
        try {
            CartService.clearCart();
            await AuthenticationService.authenticateWithEid(eid, true);
        } catch (err) {
            console.error('Unable to log in mobile user!');
        }
    }
};

const setAccountType = (custType) => {
    if (custType == 'DIST' || custType == 'DISTRIBUTOR') {
        return '10';
    } else if (custType == 'CUST' || custType == 'CUSTOMER') {
        return '20';
    } else if (custType == 'PREF' || custType == 'PREFERREDCUST' || custType == 'PREFERRED') {
        return '30';
    } else {
        return '0';
    }
};

function getPriceType(accountType) {
    return accountType == '20' ? 'RTL' : 'WHL';
}

const setUserInfo = (mobileUser) => {
    const userInfo = {
        id: mobileUser.id,
        // name: userData.person.localName,
        displayName: mobileUser.displayName || `${mobileUser.familyName}, ${mobileUser.givenName}`,
        email: mobileUser.email,
        eid: mobileUser.eid,
        accountType: setAccountType(mobileUser.beType),
        countryCd: mobileUser.country,
        priceType: getPriceType(setAccountType(mobileUser.beType)),
        // 'customerType': getCustomerType(userData.account.customerType),
        lastName: mobileUser.familyName,
        firstName: mobileUser.givenName,
        // 'loginTime': loginTime,
        personId: mobileUser.personID,
        isVolumesLoaded: false,
        emailVerified: mobileUser.isVerified,
        emailNeedsVerify: mobileUser.verifyCandidate
    }

    UserService.setUser(userInfo);
    UserService.setLoggedIn(true);
    events.publish(events.authentication.VALID, [userInfo]);
    AuthenticationService.generateMecCookies();
    VGDistInfoService.checkVolumeData().then(() => console.log('Checked Volume Data'));
};

let receivingMobile = false;
const eventListener = async (message) => {
    let data = {};

    if (typeof message.data === 'string') {
        data = JSON.parse(message.data);
    }

    if (data.cartMessage) {
        receivingMobile = true;
        if (data.shoppingContext && ShoppingContext[data.shoppingContext]) {
            ShoppingContext.setShoppingContext(ShoppingContext[data.shoppingContext]);
        }

        if (data.anonymousCartId) {
            storage.setItem('anonymousCartId', data.anonymousCartId);
        } else {
            storage.removeItem('anonymousCartId');
        }

        if (data.eid) {
            await authenticateWithEid(data.eid);
        } else if (data.user && data.user.eid) {
            setUserInfo(data.user);
        } else {
            if (AuthenticationService.isLoggedIn()) {
                CartService.clearCart();
                AuthenticationService.logout();
            }
        }

        events.setValue(events.mobile.NATIVE_INITIALIZING, [false]);
    }
};

const initalizeForMobile = async () => {
    window.addEventListener("message", eventListener)
    document.addEventListener("message", eventListener);
    window.ReactNativeWebView.postMessage(JSON.stringify({name: 'ready_to_receive', payload: {}}));

    let count = 0;
    const intervalId = setInterval(() => {
        if (receivingMobile) {
            clearInterval(intervalId);
        } else if (count > 30) {
            events.setValue(events.mobile.NATIVE_INITIALIZING, [false]);
            clearInterval(intervalId);
        }
        count += 1;
    }, 100);
};

const receiveUrlParams = () => {
    paramMap = $.getQueryParameters(window.location.search);

    if (paramMap.eid) {
        return;
    }

    let adrManaged = paramMap.code === 'complete' && paramMap.status === 'SUCCESS';
    adrEcomm3OneTimePointRedemption = paramMap.adrEcomm3OneTimePointRedemption === "true";
    user = UserService.getUser();

    //Only write query parameters to a cookie if we have any
    if (window.location.search.length > 0) {
        $.cookie(PARAMS_COOKIE, JSON.stringify(paramMap), {path: '/'});
    }

    if (paramMap.assessmentApp && paramMap.assessmentApp === 'true') {
        RunConfigService.addRunConfig({assessmentApp: true});
    }
    if (paramMap.callbackUrl) {
        RunConfigService.addRunConfig({callbackUrl: paramMap.callbackUrl});
    }
    if (paramMap.landingPage) {
        RunConfigService.addRunConfig({alternateHomeUrl: buildAlternateHomeUrl(paramMap.landingPage)});
    }
    if (paramMap.addSkusToLandingPage) {
        RunConfigService.addRunConfig({addSkusToLandingPage: paramMap.addSkusToLandingPage === 'true'})
    }

    /**
     * This is to designate cartType
     */
    if (paramMap.gift) {
        CartService.setCartProperties({isGift: JSON.parse(decodeURIComponent(paramMap.gift))});
    }

    /**
     * This is for override orders through Ecomm3
     */
    if (paramMap.orderReason && paramMap.adrContractId) {
        storage.setItem(storage.metadata.ORDER_REASON, paramMap.orderReason);
        storage.setItem(storage.metadata.ADR_OVERRIDE_ID, paramMap.adrContractId);
    }

    if (paramMap.shipAddress) {
        //Removing JSON.stringify as the URI Component is already a string?
        sessionStorage.setItem("useShipAddress", decodeURIComponent(paramMap.shipAddress));
    }

    if (paramMap.orderSkus || paramMap.adrSkus || paramMap.initAdrOverride || adrEcomm3OneTimePointRedemption) {
        (adrManaged) ? window.location = getRedirectPath() /* removes parameters from URL */ : addItemsToCart();
    }
};

/**
 * receive certain parameters from the URL.
 */
const receive = async () => {
    if (window.ReactNativeWebView) {
        events.setValue(events.mobile.NATIVE_INITIALIZING, [true]);
        await initalizeForMobile();
    } else {
        events.setValue(events.mobile.NATIVE_INITIALIZING, [false]);
        receiveUrlParams();
    }
};

export default {
    receive
};
